module.exports = __webpack_public_path__ + "49e3081736295fdb3e131a80499c3394.svg";